// extracted by mini-css-extract-plugin
module.exports = {"welcome":"Hello_welcome__1po_u","sp":"Hello_sp__16O69","button":"Hello_button__3oAXl"};